<script setup>
import { ref, onMounted, watch } from "vue";
import Input from "@/Components/Settings/Input.vue";
import TD from "@/Components/Table/Element.vue";
import axios from "axios";
import debounce from "lodash/debounce";

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(["selectPatient"]);

const input = ref(null);
const patients = ref([]);
const searchQuery = ref("");
const showResults = ref(false);

watch(
  searchQuery,
  debounce((val) => {
    searchPatient();
  }, 300)
);

function searchPatient() {
  axios
    .get("/patients/search", {
      params: {
        query: searchQuery.value,
      },
    })
    .then((response) => {
      // console.log("response", response);
      patients.value = response.data;
      showResults.value = true;
    })
    .catch((err) => {});
}

function selectPatient(patient) {
  emit("selectPatient", patient);
  showResults.value = false;
  input.value.blur();
}
</script>

<template>
  <div class="w-full relative">
    <input
      type="text"
      :disabled="props.disabled"
      ref="input"
      class="text-oteoText bg-oteoInputBG border-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm py-2 w-full"
      v-model="searchQuery"
      @focus="
        () => {
          searchPatient();
          showResults = true;
        }
      "
      @blur="showResults = false"
    />
    <div
      v-if="showResults"
      class="bg-white border border-gray-200 rounded-sm absolute shadow-md p-4 mt-1"
    >
      <div v-if="patients.length == 0">Keine Treffer</div>
      <div
        v-if="patients.length > 0"
        class="flex max-h-[200px] overflow-scroll"
      >
        <table class="w-[605px]">
          <thead class="bg-white border-b sticky top-0">
            <tr>
              <th
                scope="col"
                class="text-sm font-medium text-gray-900 px-6 py-4 text-left border-r-2"
              >
                Patientennummer
              </th>
              <th
                scope="col"
                class="text-sm font-medium text-gray-900 px-6 py-4 text-left border-x-2"
              >
                Nachname
              </th>
              <th
                scope="col"
                class="text-sm font-medium text-gray-900 px-6 py-4 text-left border-x-2"
              >
                Vorname
              </th>
              <th
                scope="col"
                class="text-sm font-medium text-gray-900 px-6 py-4 text-left border-l-2"
              >
                Geburtsdatum
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="patient in patients"
              :key="patient.id"
              class="border-b cursor-pointer"
              @mousedown.prevent
              @click="selectPatient(patient)"
            >
              <TD>{{ patient.patient_number }}</TD>
              <TD>{{ patient.lastname }}</TD>
              <TD>{{ patient.firstname }}</TD>
              <TD>{{ patient.birthday_string || "-" }} </TD>
            </tr>

            <tr class="">
              <TD class="border-l-0"></TD>
              <TD></TD>
              <TD></TD>
              <TD class="border-r-0"></TD>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
